import React, { useEffect } from 'react'
import { EvidenceWrapper } from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import { AccordionGridBody } from 'src/components/Reusable/Grid/Accordion'
import { useLocation } from 'react-router-dom'
import { ReceptorScanContextProvider } from 'src/context/ReceptorScanStatus'
import { GatekeeperFlag, IsGatekeeperEnabled } from 'src/context/Gatekeeper'
import { useNewModel } from 'src/components/async/hooks/useNewModel'
import { EvidenceAbsoluteRoutes } from 'src/components/Reusable/RootPage/RootPage.constants'
import { useIsContentSearchActive } from 'src/Utils/search/search.hooks'
import { useEvidenceIndexGridTemplateColumns } from '../evidence.hooks'
import {
  EvidenceIndexGridHeader,
  evidenceWrapperRowItems,
} from './EvidenceGrid.components'
import { StyledEvidenceGrid } from './EvidenceGrid.styles'

export const EvidenceGrid = ({
  evidenceWrappers,
  onUpdate,
}: {
  evidenceWrappers: EvidenceWrapper[]
  onUpdate: () => Promise<void>
}): JSX.Element => {
  const location = useLocation()
  const isContentSearchActive = useIsContentSearchActive()
  const newModel = useNewModel()
  useEffect(() => {
    const savedPosition = sessionStorage.getItem(
      `scrollPosition-${location.pathname}`,
    )
    if (savedPosition) {
      window.scrollTo(0, parseInt(savedPosition, 10))
      sessionStorage.removeItem(`scrollPosition-${location.pathname}`)
    }
  }, [location])

  const hasSharepoint = IsGatekeeperEnabled(GatekeeperFlag.SHAREPOINT)
  const isEvidenceIndexPage = location.pathname.includes(
    EvidenceAbsoluteRoutes.INDEX,
  )
  const showContentMatchColumn = isContentSearchActive && isEvidenceIndexPage
  const gridTemplateColumns = useEvidenceIndexGridTemplateColumns(hasSharepoint)
  const templateColumns = showContentMatchColumn
    ? `min-content ${gridTemplateColumns}`
    : gridTemplateColumns

  return (
    <ReceptorScanContextProvider>
      <StyledEvidenceGrid gridTemplateColumns={templateColumns}>
        <EvidenceIndexGridHeader
          showContentMatchColumn={showContentMatchColumn}
        />
        <AccordionGridBody
          items={evidenceWrapperRowItems({
            evidenceWrappers,
            onUpdate,
            newModel,
          })}
          gridTemplateColumns={templateColumns}
          nothingToShow={<></>}
        />
      </StyledEvidenceGrid>
    </ReceptorScanContextProvider>
  )
}
